import { defineRequest } from "../axios"
import type { ConfigurationResponse, UpdateConfigurationPayload } from "./types"

// 取得系統設定
export const getConfiguration = defineRequest<ConfigurationResponse>({
    url: "/systems/configuration/",
    method: "get",
})

// 設置系統設定
export const updateConfiguration = defineRequest<ConfigurationResponse, UpdateConfigurationPayload>({
    url: "/systems/configuration/",
    method: "put",
})
